import axiosInstance from "../axios/axiosInstance";
import { getActiveCompanyId } from "utils/companyContext";

const companyId = () => getActiveCompanyId();

export const getContractorProfile = async (contractorId) => {
    return (await axiosInstance.get(`/companies/${companyId()}/contractors/${contractorId}`)).data;
};

export const updateContractorProfile = async (contractorId, payload) => {
    return (await axiosInstance.put(`/companies/${companyId()}/contractors/${contractorId}`, payload)).data;
};

export const getCompanyPayrolls = async () => {
    const res = await axiosInstance.get(`/companies/${companyId()}/payrolls`, {
        params: { page: 1, pageSize: 1000 },
    });
    const data = res.data;
    return Array.isArray(data) ? data : (data?.data ?? []);
};

export const previewPayroll = async (payrollId) => {
    return (await axiosInstance.get(`/companies/${companyId()}/payrolls/${payrollId}/preview`)).data;
};

export const getContractorDocuments = async (contractorId, year) => {
    const params = { contractorId };
    if (year) params.year = year;
    const res = await axiosInstance.get(
        `/companies/${companyId()}/documents/contractor_tax_documents`,
        { params }
    );
    const data = res.data;
    return Array.isArray(data) ? data : (data?.data ?? []);
};

export const downloadContractorDocument = async (documentId) => {
    const res = await axiosInstance.get(
        `/companies/${companyId()}/documents/contractor_tax_documents/${documentId}/download`,
        { responseType: "blob" }
    );
    return { url: URL.createObjectURL(res.data) };
};

export const getWorkplaces = async () => {
    const res = await axiosInstance.get(`/companies/${companyId()}/workplaces`);
    const data = res.data;
    return Array.isArray(data) ? data : (data?.data ?? data?.items ?? []);
};

export const getDepartments = async () => {
    const res = await axiosInstance.get(`/companies/${companyId()}/departments`);
    const data = res.data;
    return Array.isArray(data) ? data : (data?.data ?? data?.items ?? []);
};

export const changePassword = async (payload) => {
    return (await axiosInstance.post(`/auth/change-password`, payload)).data;
};

export const changeEmail = async (payload) => {
    return (await axiosInstance.post(`/auth/change-email`, payload)).data;
};

export const clockIn = async (contractorId, workplaceId) => {
    return (await axiosInstance.post(`/companies/${companyId()}/timecards/clock-in`, {
        contractorId,
        workplaceId: workplaceId || null,
    })).data;
};

export const clockOut = async (timecardId) => {
    return (await axiosInstance.patch(`/companies/${companyId()}/timecards/${timecardId}/clock-out`)).data;
};

export const addBreak = async (timecardId, paid, durationSeconds) => {
    return (await axiosInstance.patch(`/companies/${companyId()}/timecards/${timecardId}/break`, {
        paid,
        durationSeconds,
    })).data;
};

export const getTimecards = async (contractorId) => {
    const res = await axiosInstance.get(`/companies/${companyId()}/timecards`, {
        params: { contractorId }
    });
    return Array.isArray(res.data) ? res.data : (res.data?.data ?? []);
};

export const getContractorBankAccounts = async (contractorId) => {
    try {
        const res = await axiosInstance.get(`/companies/${companyId()}/contractors/${contractorId}/bank_accounts`);
        const data = res.data;
        return Array.isArray(data) ? data : (data?.data ?? data?.items ?? []);
    } catch { return []; }
};
